module.exports = __webpack_public_path__ + "img/hometop_item_imgs02.7e7fcf04.png";